import React from 'react';
import PropTypes from 'prop-types';
import { I18nText } from '@welldev-group/react-comp-lib';
import doneMark from '../../../../assets/images/done-24px.svg';

const tableHeader = [
  { id: 0, name: <I18nText id="plans.free" /> },
  { id: 1, name: <I18nText id="plans.lite" /> },
  { id: 2, name: <I18nText id="plans.growth" /> },
  { id: 3, name: <I18nText id="plans.enterprise" /> },
  { id: 4, name: <I18nText id="plans.custom" /> },
];

const planOptions = [
  {
    id: 0,
    name: <I18nText id="pricing.table.feature.subscription.search" />,
    isFree: doneMark,
    isLite: doneMark,
    isGrowth: doneMark,
    isEnterprise: doneMark,
    isCustom: doneMark,
  },
  {
    id: 1,
    name: <I18nText id="pricing.table.feature.subscription.bookings" />,
    isFree: doneMark,
    isLite: doneMark,
    isGrowth: doneMark,
    isEnterprise: doneMark,
    isCustom: doneMark,
  },
  {
    id: 2,
    name: <I18nText id="pricing.table.feature.subscription.traveler" />,
    isFree: doneMark,
    isLite: doneMark,
    isGrowth: doneMark,
    isEnterprise: doneMark,
    isCustom: doneMark,
  },
  {
    id: 3,
    name: <I18nText id="pricing.table.feature.subscription.corporate" />,
    isFree: doneMark,
    isLite: doneMark,
    isGrowth: doneMark,
    isEnterprise: doneMark,
    isCustom: doneMark,
  },
  {
    id: 4,
    name: <I18nText id="pricing.table.feature.subscription.quotes" />,
    isFree: doneMark,
    isLite: doneMark,
    isGrowth: doneMark,
    isEnterprise: doneMark,
    isCustom: doneMark,
  },
  {
    id: 5,
    name: <I18nText id="pricing.table.feature.subscription.ndc" />,
    isFree: doneMark,
    isLite: doneMark,
    isGrowth: doneMark,
    isEnterprise: doneMark,
    isCustom: doneMark,
  },
];

const PricingTable = ({ isSuperAdmin }) => {
  const filterHeaders = isSuperAdmin
    ? tableHeader
    : tableHeader.filter(header => header.id !== 4);
  return (
    <>
      <div className="pricing-table">
        <div className="pricing-table__header">
          <I18nText id="pricing.table.header.details" />
        </div>
        <table className="pricing-table__table">
          <thead>
            <tr>
              <th className="pricing-table__header-feature">
                <I18nText id="pricing.table.feature.header" />
              </th>
              {filterHeaders.map(({ name, id }) => (
                <th className="pricing-table__header-plan" key={id}>
                  {name}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {planOptions.map(
              ({
                id,
                name,
                isFree,
                isLite,
                isGrowth,
                isEnterprise,
                isCustom,
              }) => (
                <tr key={id}>
                  <td className="pricing-table__data">{name}</td>
                  <td className="pricing-table__plan">
                    <img src={isFree} alt="check" />
                  </td>
                  <td className="pricing-table__plan">
                    <img src={isLite} alt="check" />
                  </td>
                  <td className="pricing-table__plan">
                    <img src={isGrowth} alt="check" />
                  </td>
                  <td className="pricing-table__plan">
                    <img src={isEnterprise} alt="check" />
                  </td>
                  {isSuperAdmin && (
                    <td className="pricing-table__plan">
                      <img src={isCustom} alt="check" />
                    </td>
                  )}
                </tr>
              ),
            )}
          </tbody>
        </table>
      </div>
      <hr className="pricing-table__border" />
    </>
  );
};

PricingTable.propTypes = {
  isSuperAdmin: PropTypes.bool.isRequired,
};

export default PricingTable;
